import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { UPDATE_SOCIAL_CHART_DATA_BEGIN, logError, updateSocialChartDataSuccess } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function updateSocialChartData(action$, state$) {
    return action$.pipe(ofType(UPDATE_SOCIAL_CHART_DATA_BEGIN), mergeMap(function(action) {
        var dataToSave = action.data;
        if (typeof action.data !== "string") {
            dataToSave = JSON.stringify(action.data);
        }
        return from(SocialAPIUtils.savePluginData(action.pluginId || "", action.nodeId, dataToSave)).pipe(switchMap(function(response) {
            var savedUserData = response ? response.data : null;
            if ((response === null || response === void 0 ? void 0 : response.data) && typeof response.data === "string") {
                try {
                    savedUserData = JSON.parse(response.data);
                } catch (err) {
                    console.warn(err);
                }
            }
            if (savedUserData) {
                return [
                    updateSocialChartDataSuccess({
                        nodeId: response.node_id,
                        socialChartData: {
                            meta: response.meta,
                            data: savedUserData
                        }
                    })
                ];
            } else {
                return [
                    logError({
                        error: new Error("An error occurred while updating user data. The response did not contain valid data. Check the browser console and the network tab for more information."),
                        key: "update_social_chart_data"
                    })
                ];
            }
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "update_social_chart_data"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "update_social_chart_data"
        }));
    }));
}
